import * as cmUtil from "@/utils/cmUtil";
import { isLoginApi } from "./cmApi";
import { api } from "@/plugins/api";
import router from "@/router";
const url = "/api/v1"; // inject("url_prefix");



/*
SET제품 체크 API
parameter (goodsSn:제품번호)
return (
세트제품인경우 {
  set: true,
  matnr: 세트제품 ID
}
세트제품이 아닌경우 { set: false }
)
*/
export async function checkSetProduct(goodsSn) {
  const param = { params: { goodsSn: goodsSn } };
  const res = {};
  try {
    const chkSetRes = await api.get(`${url}/order/checkSetProduct`, param);
    if (chkSetRes.resultCode === 200) {
      if (chkSetRes.data.matnr != null) {
        const paraSub = { params: {goodsSn: chkSetRes.data.goodsSn}}
         const chkSetProd = await api.get(`${url}/order/checkSetProductZzprdTyp`, paraSub);
        if(chkSetProd.data.zzprdTyp == 'A'){
            // 개별제품선택
            res.set = false;
            res.matnr = chkSetRes.data.subMatnr; // 개별제품 자재번호
            res.goodsSn = goodsSn; // 개별제품 일련번호
            return res;
        }else{
            const isIndvdPrdct = await checkSetProductAlert(
              chkSetRes.data.subZzmaktx,
              chkSetRes.data.zzmaktx
            );
          if (!isIndvdPrdct) {
            // 세트제품선택
            res.set = true;
            res.matnr = chkSetRes.data.matnr; // 세트제품 자재번호
            res.goodsSn = chkSetRes.data.goodsSn; // 세트제품 일련번호
            return res;
          } else {
            // 개별제품선택
            res.set = false;
            res.matnr = chkSetRes.data.subMatnr; // 개별제품 자재번호
            res.goodsSn = goodsSn; // 개별제품 일련번호
            return res;
          }
        }
      } else {
        return { set: false };
      }
    } else {
      await cmUtil.alert(chkSetRes.message);
      return;
    }
  } catch (e) {
    console.log("error=" + e.message);
  }
}

// SET제품 체크 alert
// parameter (제품ID, 세트제품ID)
// return (true: 개별제품 선택, false: 세트제품 선택)
export async function checkSetProductAlert(subZzmaktx, zzmaktx) {
  const opts = {
    type: "set",
    subZzmaktx: subZzmaktx,
    zzmaktx: zzmaktx,
  };
  return await cmUtil.confirm("msg", opts);
}

/*
임시주문 생성후 주문서 화면 이동
parameter = {
  goodsSn:goodsSn, //상품번호
  goodsQty:goodsQty, //주문개수  
  zempNo:zempNo, //영업사원아이디
  path: path, //주문호출경로
}
*/
export async function createTempOrder(parm = {}) {
  // 값 유효성 체크
  let validItems = [
    { name: "goodsSn", title: "상품번호" },
    { name: "zempNo", title: "영업사원 아이디" },
  ];
  let validMsg = "";
  for (let i = 0; i < validItems.length; i++) {
    if (parm[validItems[i].name] == null || parm[validItems[i].name] == "") {
      validMsg += `${validItems[i].title} 정보가 없습니다.`;
      break;
    }
  }
  if (validMsg) {
    cmUtil.toast(`${validMsg}`, { type: "basket" });
    return false;
  }

  if (!(await isLoginApi()).data) {
    cmUtil.toast(`로그인하시기 바랍니다.`, { type: "basket" });
    return false;
  }

  // 세트제품 체크
  // 액형 조회
  const itemResult = await api.get(`${url}/order/selectItemZzlqdCls`, {
    params: { goodsSn: parm.goodsSn },
  });
  const zzlqdCls = itemResult.data.zzlqdCls;
  // 주제인 경우만 세트제품 체크
  if (zzlqdCls === "A") {
    const res = await checkSetProduct(parm.goodsSn);
    if (res.set) {
      parm.goodsSn = res.goodsSn;
    }
  }

  const params = {
    masterData: {},
    detailList: [{}],
  };

  params.masterData.orderTmpStatusCd = 1; // 임시주문상태코드 - 1:주문대기, 2:주문완료
  params.masterData.zempNo = parm.zempNo; // 직원사번
  params.masterData.dmndScrnPath = parm.path; // 주문호출경로

  params.detailList[0].goodsSn = parm.goodsSn;
  params.detailList[0].goodsQty = parm.goodsQty || 1;

  // 전송
  const res = await api.post(`${url}/order/saveOrderTemp`, params);
  if (res.resultCode === 200) {
    const orderTmpSn = res.data;
    router.push({
      path: "/paintpro/orderOrder",
      query: { orderTmpSn: orderTmpSn },
    });
  } else {
    await cmUtil.alert(res.message);
    return;
  }
}

/*
 다시주문
 parameter = {
  orderSn = orderSn, // 주문일련번호
 }
 */
export async function reOrder(parm = {}) {
  const param = {
    orderSn: parm.orderSn,
  };

  const res = await api.get(`${url}/order/reOrder`, { params: param });
  if (res.resultCode === 200) {
    const orderTmpSn = res.data.orderTmpSn;
    const dlvrChng = res.data.dlvrChng;
    const beOrderNo = res.data.beOrderNo;
    router.push({
      path: "/paintpro/orderOrder",
      query: { orderTmpSn: orderTmpSn, dlvrChng: dlvrChng, beOrderNo: beOrderNo},
    });
  }
}
